import { render, staticRenderFns } from "./TrustPilot.vue?vue&type=template&id=0409a7cf"
import script from "./TrustPilot.vue?vue&type=script&lang=js"
export * from "./TrustPilot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports